import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { FONT } from '../../styles/emotion';
import COLORS, { COLORS_SEMANTIC } from '../../styles/emotion/colors3';

export const StyledBanner = styled.div<{ type: string }>`
  align-items: center;
  display: inline-flex;
  flex-flow: row;
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  height: 44px;
  justify-content: center;
  letter-spacing: 0;
  line-height: ${FONT.FONT_SIZE_SMALL};
  padding: ${FONT.FONT_SIZE_SMALLER} 57px;

  ${({ type }) => {
    switch (type) {
      case 'warning':
        return css`
          background-color: ${COLORS_SEMANTIC.NEGATIVE_100};
          color: ${COLORS.WHITE_100};
        `;
      case 'minorwarn':
        return css`
          background-color: ${COLORS_SEMANTIC.NEGATIVE_030};
          color: ${COLORS.BLACK_100};
        `;
      case 'marketing':
        return css`
          background-color: ${COLORS.BAY_100};
          color: ${COLORS.WHITE_100};
          display: flex;
          max-width: 100%;
          width: 100%;
        `;
      case 'informational':
        return css`
          background-color: ${COLORS_SEMANTIC.INFORMATIONAL_100};
          color: ${COLORS.WHITE_100};
        `;
      case 'error':
        return css`
          background-color: ${COLORS_SEMANTIC.NEGATIVE_100};
          color: ${COLORS.WHITE_100};
        `;
      default:
        return css`
          background-color: ${COLORS_SEMANTIC.NEGATIVE_030};
          color: ${COLORS.BLACK_100};
        `;
    }
  }};

  a {
    &,
    &:link,
    &:visited,
    &:hover,
    &:active {
      color: inherit;
      text-decoration: underline;
    }
  }
`;
